import { Link } from "react-router-dom";
import { site, stats } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20night%20newsroom%20backdrop%20with%20crimson%20and%20amber%20spotlights%20cutting%20through%20haze%2C%20blurred%20pin%20boards%20and%20glowing%20screens%2C%20no%20people%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20and%20film%20grain&width=1800&height=1000&seq=hero-home&orientation=landscape"
        alt="网红大瓜站首屏氛围配图，抽象夜间编辑部灯光"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 to-transparent" />

      <div className="relative z-10 mx-auto flex w-full max-w-[1400px] flex-col justify-center px-4 py-20 md:px-6 md:py-28 lg:min-h-[600px]">
        <span className="gg-fade-up mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <span className="gg-pulse-dot h-1.5 w-1.5 rounded-full bg-accent-500" />
          {site.tagline} · 每日整理最新猛料
        </span>

        <h1 className="gg-fade-up mb-5 max-w-3xl font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl lg:text-7xl">
          {site.name}
          <span className="mt-2 block text-lg font-medium tracking-[0.35em] text-accent-400 md:text-2xl">
            {site.slogan}
          </span>
        </h1>

        <p className="gg-fade-up mb-8 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          从热搜里翻不完整的事，这里帮你归好。网红大瓜把最新
          <strong className="font-semibold text-background-50">重磅爆料</strong>、被称作
          <strong className="font-semibold text-background-50">惊天大瓜</strong>
          的事件原帖与关键截图集中归档，配上完整时间线与双方回应，让你五分钟看懂一件事的来龙去脉，
          <strong className="font-semibold text-background-50">热门猛料</strong>持续更新。
        </p>

        <div className="gg-fade-up mb-12 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#featured"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-fire-line" />
            查看今日重磅爆料
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:border-accent-500 hover:text-accent-400 cursor-pointer"
          >
            <i className="ri-send-plane-line" />
            我要投稿爆料
          </Link>
        </div>

        <dl className="gg-fade-up grid grid-cols-2 gap-4 border-t border-background-50/15 pt-6 md:grid-cols-4 md:gap-8">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                {item.value}
              </dt>
              <dd className="mt-1 text-xs text-background-300 md:text-sm">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}